<template>
  <div id="wizard" class="mb-10">
    <v-overlay color="#000" opacity="0.40" :absolute="true" :value="isLoading" :z-index="3">
      <v-progress-circular indeterminate color="primary" :size="60" :width="5" class="mr-10px" />
      <span v-if="!isSaving">Prebieha načítanie dát, prosím počkajte ...</span>
      <span v-if="isSaving">Prebieha ukladanie dát, prosím počkajte ...</span>
    </v-overlay>
    <!-- <v-dialog
      v-model="showCenaWarning"
      overlay-color="#000"
      overlay-opacity="0.66"
      persistent
      eager
      max-width="500"
    >
      <v-card>
        <v-card-title class="d-flex justify-space-between">
          <span class="gs100 f16">Upozornenie</span>
          <v-btn icon @click="showCenaWarning = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="f16 white100">
          Suma cien položiek technológie nie je rovnaká ako cena predmetu bez DPH. Upravte prosím
          ceny položiek.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="btn-secondary" @click="showCenaWarning = false"> OK </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->
    <v-container class="pa-0">
      <h1 class="mt-45px mb-28px">Preberací protokol</h1>
      <v-card class="card">
        <v-form ref="formBasicInfo" autocomplete="off">
          <h2 class="mb-6">Základné informácie o predmete</h2>
          <v-row>
            <v-col cols="4">
              <date-picker
                label="Dátum prvej platby"
                placeholder="DD/MM/YYYY"
                v-model="preberaciProtokol.datum_prvej_platby"
                :required="getParameter('isRequired', 'datum_prvej_platby')"
                :isEnabled="getParameter('isEnabled', 'datum_prvej_platby')"
                v-if="getParameter('isDisplayed', 'datum_prvej_platby')"
              />
            </v-col>
            <v-col cols="4">
              <date-picker
                label="Dátum prebratia"
                placeholder="DD/MM/YYYY"
                v-model="preberaciProtokol.datum_prebratia"
                :required="getParameter('isRequired', 'datum_prebratia')"
                :isEnabled="getParameter('isEnabled', 'datum_prebratia')"
                v-if="getParameter('isDisplayed', 'datum_prebratia')"
              />
            </v-col>
            <v-col cols="4">
              <button-group
                switchBtn
                :dynamic="false"
                :items="jazdenyItems"
                v-model="preberaciProtokol.ojazdene_vozidlo"
                :class="{
                  required: getParameter('isRequired', 'ojazdene_vozidlo'),
                }"
                :isEnabled="getParameter('isEnabled', 'ojazdene_vozidlo')"
                :rules="getParameter('isRequired', 'ojazdene_vozidlo') ? requiredRule : []"
                v-show="getParameter('isDisplayed', 'ojazdene_vozidlo')"
              />
            </v-col>
            <v-col cols="4">
              <v-autocomplete
                append-icon="mdi-chevron-down"
                outlined
                class="dynamic-input-control"
                label="Druh predmetu"
                :items="druhyTovaruData"
                item-text="displayMember"
                item-value="valueMember"
                v-model="preberaciProtokol.id_druhu_tovaru"
                :class="{
                  required: getParameter('isRequired', 'id_druhu_tovaru'),
                }"
                :disabled="!getParameter('isEnabled', 'id_druhu_tovaru')"
                :rules="getParameter('isRequired', 'id_druhu_tovaru') ? requiredRule : []"
                v-if="getParameter('isDisplayed', 'id_druhu_tovaru')"
              />
            </v-col>
            <v-col cols="8">
              <v-checkbox
                class="dynamic_check_box mt-0 pt-0"
                label="Fyzicky overený"
                v-model="preberaciProtokol.ma_overeny_pp"
                :class="{
                  required: getParameter('isRequired', 'ma_overeny_pp'),
                }"
                :disabled="!getParameter('isEnabled', 'ma_overeny_pp')"
                :rules="getParameter('isRequired', 'ma_overeny_pp') ? requiredRule : []"
                v-if="getParameter('isDisplayed', 'ma_overeny_pp')"
                :false-value="0"
                :true-value="1"
                hide-details
                outlined
              />
              <v-checkbox
                class="dynamic_check_box mt-0 pt-2"
                label="Predmet sa bude registrovať na Dopravnom inšpektoráte"
                v-model="preberaciProtokol.podlieha_evidencii_na_di"
                :class="{
                  required: getParameter('isRequired', 'podlieha_evidencii_na_di'),
                }"
                :disabled="!getParameter('isEnabled', 'podlieha_evidencii_na_di')"
                :rules="getParameter('isRequired', 'podlieha_evidencii_na_di') ? requiredRule : []"
                v-if="getParameter('isDisplayed', 'podlieha_evidencii_na_di')"
                :false-value="0"
                :true-value="1"
                hide-details
                outlined
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="8">
              <v-text-field
                class="dynamic-input-control"
                label="Názov predmetu"
                v-model="preberaciProtokol.nazov"
                :class="{
                  required: getParameter('isRequired', 'nazov'),
                }"
                :disabled="!getParameter('isEnabled', 'nazov')"
                :rules="getParameter('isRequired', 'nazov') ? requiredRule : []"
                v-if="getParameter('isDisplayed', 'nazov')"
                outlined
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="8">
              <v-textarea
                class="dynamic-input-control"
                label="Špecifikácia"
                v-model="preberaciProtokol.specifikacia"
                :class="{
                  required: getParameter('isRequired', 'specifikacia'),
                }"
                :disabled="!getParameter('isEnabled', 'specifikacia')"
                :rules="getParameter('isRequired', 'specifikacia') ? requiredRule : []"
                v-if="getParameter('isDisplayed', 'specifikacia')"
                outlined
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <date-picker
                label="Termín vystavenia OEV"
                placeholder="DD/MM/YYYY"
                v-model="preberaciProtokol.datum_vystavenia_oev"
                :required="getParameter('isRequired', 'datum_vystavenia_oev')"
                :isEnabled="getParameter('isEnabled', 'datum_vystavenia_oev')"
                v-if="getParameter('isDisplayed', 'datum_vystavenia_oev')"
              />
            </v-col>
            <v-col cols="4">
              <date-picker
                label="Termín dodania OEV"
                placeholder="DD/MM/YYYY"
                v-model="preberaciProtokol.datum_dodania_oev"
                :required="getParameter('isRequired', 'datum_dodania_oev')"
                :isEnabled="getParameter('isEnabled', 'datum_dodania_oev')"
                v-if="getParameter('isDisplayed', 'datum_dodania_oev')"
              />
            </v-col>
            <v-col cols="4">
              <v-text-field
                class="dynamic-input-control"
                label="Číslo karosérie/VIN"
                v-model="preberaciProtokol.vyrobne_cislo"
                @focusout="checkVin(true)"
                :loading="vinLoading"
                :class="{
                  required: getParameter('isRequired', 'vyrobne_cislo'),
                }"
                :disabled="!getParameter('isEnabled', 'vyrobne_cislo')"
                :rules="
                  getParameter('isRequired', 'vyrobne_cislo')
                    ? [requiredRule[0], vinUsedRule]
                    : [vinUsedRule]
                "
                v-if="getParameter('isDisplayed', 'vyrobne_cislo')"
                outlined
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <v-text-field
                outlined
                class="dynamic-input-control"
                label="Značka"
                v-model="preberaciProtokol.znacka"
                :class="{
                  required: getParameter('isRequired', 'znacka'),
                }"
                :disabled="!getParameter('isEnabled', 'znacka')"
                :rules="getParameter('isRequired', 'znacka') ? requiredRule : []"
                v-if="getParameter('isDisplayed', 'znacka')"
              />
            </v-col>
            <v-col cols="4">
              <v-text-field
                outlined
                class="dynamic-input-control"
                label="Model"
                v-model="preberaciProtokol.model"
                :class="{
                  required: getParameter('isRequired', 'model'),
                }"
                :disabled="!getParameter('isEnabled', 'model')"
                :rules="getParameter('isRequired', 'model') ? requiredRule : []"
                v-if="getParameter('isDisplayed', 'model')"
              />
            </v-col>
            <v-col cols="4">
              <v-text-field
                outlined
                class="dynamic-input-control"
                label="Verzia modelu"
                v-model="preberaciProtokol.verzia_modelu"
                :class="{
                  required: getParameter('isRequired', 'verzia_modelu'),
                }"
                :disabled="!getParameter('isEnabled', 'verzia_modelu')"
                :rules="getParameter('isRequired', 'verzia_modelu') ? requiredRule : []"
                v-if="getParameter('isDisplayed', 'verzia_modelu')"
              />
            </v-col>
            <v-col cols="4">
              <numeric-text-box
                label="Cenníková cena"
                suffix="€"
                v-model="preberaciProtokol.cennikova_cena_s_dph"
                :class="{
                  required: getParameter('isRequired', 'cennikova_cena_s_dph'),
                }"
                :isEnabled="getParameter('isEnabled', 'cennikova_cena_s_dph')"
                :rules="getParameter('isRequired', 'cennikova_cena_s_dph') ? requiredRule : []"
                v-if="getParameter('isDisplayed', 'cennikova_cena_s_dph')"
              />
            </v-col>
            <v-col cols="4">
              <numeric-text-box
                class="dynamic-input-control"
                label="Výkon motora"
                outlined
                suffix="kW"
                v-model="preberaciProtokol.vykon_motora"
                :class="{
                  required: getParameter('isRequired', 'vykon_motora'),
                }"
                :decimalPlaces="0"
                :isEnabled="getParameter('isEnabled', 'vykon_motora')"
                :rules="getParameter('isRequired', 'vykon_motora') ? requiredRule : []"
                v-if="getParameter('isDisplayed', 'vykon_motora')"
              />
            </v-col>
            <v-col cols="4">
              <numeric-text-box
                label="Objem motora"
                :decimalPlaces="0"
                v-model="preberaciProtokol.objem_motora"
                :class="{
                  required: getParameter('isRequired', 'objem_motora'),
                }"
                :isEnabled="getParameter('isEnabled', 'objem_motora')"
                :rules="getParameter('isRequired', 'objem_motora') ? requiredRule : []"
                v-if="getParameter('isDisplayed', 'objem_motora')"
              >
                <template v-slot:append>cm<sup style="top: -0.2em">3</sup></template>
              </numeric-text-box>
            </v-col>
            <v-col cols="4">
              <numeric-text-box
                class="dynamic-input-control"
                label="Počiatočný stav"
                outlined
                suffix="km"
                v-model="preberaciProtokol.pociatocny_stav_km"
                :class="{
                  required: getParameter('isRequired', 'pociatocny_stav_km'),
                }"
                :decimalPlaces="0"
                :isEnabled="getParameter('isEnabled', 'pociatocny_stav_km')"
                :rules="getParameter('isRequired', 'pociatocny_stav_km') ? requiredRule : []"
                v-if="getParameter('isDisplayed', 'pociatocny_stav_km')"
              />
            </v-col>
            <v-col cols="4">
              <numeric-text-box
                class="dynamic-input-control"
                label="Celková hmotnosť"
                outlined
                suffix="kg"
                :decimalPlaces="0"
                v-model="preberaciProtokol.hmotnost_celkova"
                :class="{
                  required: getParameter('isRequired', 'hmotnost_celkova'),
                }"
                :isEnabled="getParameter('isEnabled', 'hmotnost_celkova')"
                :rules="getParameter('isRequired', 'hmotnost_celkova') ? requiredRule : []"
                v-if="getParameter('isDisplayed', 'hmotnost_celkova')"
              />
            </v-col>
            <v-col cols="4">
              <v-text-field
                class="dynamic-input-control"
                label="Rok výroby"
                outlined
                v-model="preberaciProtokol.rok_vyroby"
                :class="{
                  required: getParameter('isRequired', 'rok_vyroby'),
                }"
                :disabled="!getParameter('isEnabled', 'rok_vyroby')"
                :rules="getParameter('isRequired', 'rok_vyroby') ? requiredRule : []"
                v-if="getParameter('isDisplayed', 'rok_vyroby')"
              />
            </v-col>
            <v-col cols="4">
              <date-picker
                label="Dátum prvej registrácie"
                placeholder="DD/MM/YYYY"
                v-model="preberaciProtokol.datum_1_evidencie"
                :required="getParameter('isRequired', 'datum_1_evidencie')"
                :isEnabled="getParameter('isEnabled', 'datum_1_evidencie')"
                v-if="getParameter('isDisplayed', 'datum_1_evidencie')"
              />
            </v-col>
            <v-col cols="4">
              <numeric-text-box
                class="dynamic-input-control"
                label="Počet náprav"
                outlined
                v-model="preberaciProtokol.pocet_naprav"
                :class="{
                  required: getParameter('isRequired', 'pocet_naprav'),
                }"
                :decimalPlaces="0"
                :isEnabled="getParameter('isEnabled', 'pocet_naprav')"
                :rules="getParameter('isRequired', 'pocet_naprav') ? requiredRule : []"
                v-if="getParameter('isDisplayed', 'pocet_naprav')"
              />
            </v-col>
            <v-col cols="4">
              <v-autocomplete
                append-icon="mdi-chevron-down"
                outlined
                class="dynamic-input-control"
                label="Palivo"
                :items="typyMotoraData"
                item-text="displayMember"
                item-value="valueMember"
                v-model="preberaciProtokol.typ_motora"
                :class="{
                  required: getParameter('isRequired', 'typ_motora'),
                }"
                :disabled="!getParameter('isEnabled', 'typ_motora')"
                :rules="getParameter('isRequired', 'typ_motora') ? requiredRule : []"
                v-if="getParameter('isDisplayed', 'typ_motora')"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card>
      <div v-if="jeAuto === false">
        <v-card
          class="mt-24px card"
          v-for="(tech, index) in preberaciProtokolTechnologie"
          :key="index"
          :id="'technologia' + tech.pkid"
        >
          <v-form :ref="'form' + tech.pkid" autocomplete="off">
            <v-row>
              <v-col cols="11">
                <h2>{{ tech.nazov_predmetu }}</h2>
              </v-col>
              <v-col cols="1">
                <v-btn @click="tech.active = !tech.active" class="btn-secondary right" icon>
                  <v-icon :class="{ 'rotate-180': tech.active }">mdi-chevron-down</v-icon>
                </v-btn>
              </v-col>
            </v-row>

            <v-expand-transition>
              <div class="mt-6" v-show="tech.active">
                <v-row>
                  <v-col cols="4">
                    <v-text-field
                      class="dynamic-input-control"
                      label="Názov predmetu"
                      v-model="tech.nazov_predmetu"
                      :class="{
                        required: getParameter('isRequired', 'nazov_predmetu', tech.pkid),
                      }"
                      :disabled="!getParameter('isEnabled', 'nazov_predmetu', tech.pkid)"
                      :rules="
                        getParameter('isRequired', 'nazov_predmetu', tech.pkid) ? requiredRule : []
                      "
                      v-if="getParameter('isDisplayed', 'nazov_predmetu', tech.pkid)"
                      outlined
                    />
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      class="dynamic-input-control"
                      label="Výrobné číslo"
                      v-model="tech.vyrobne_cislo"
                      :class="{
                        required: getParameter('isRequired', 'vyrobne_cislo', tech.pkid),
                      }"
                      :disabled="!getParameter('isEnabled', 'vyrobne_cislo', tech.pkid)"
                      :rules="
                        getParameter('isRequired', 'vyrobne_cislo', tech.pkid) ? requiredRule : []
                      "
                      v-if="getParameter('isDisplayed', 'vyrobne_cislo', tech.pkid)"
                      outlined
                    />
                  </v-col>
                  <v-col cols="4">
                    <numeric-text-box
                      label="Cena bez DPH"
                      suffix="€"
                      v-model="tech.cena_bez_dph"
                      :class="{
                        required: getParameter('isRequired', 'cena_bez_dph', tech.pkid),
                      }"
                      :isEnabled="getParameter('isEnabled', 'cena_bez_dph', tech.pkid)"
                      :rules="
                        getParameter('isRequired', 'cena_bez_dph', tech.pkid) ? requiredRule : []
                      "
                      v-if="getParameter('isDisplayed', 'cena_bez_dph', tech.pkid)"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="4">
                    <v-text-field
                      class="dynamic-input-control"
                      label="Rok výroby"
                      outlined
                      v-model="tech.rok_vyroby"
                      :class="{
                        required: getParameter('isRequired', 'rok_vyroby', tech.pkid),
                      }"
                      :disabled="!getParameter('isEnabled', 'rok_vyroby', tech.pkid)"
                      :rules="
                        getParameter('isRequired', 'rok_vyroby', tech.pkid) ? requiredRule : []
                      "
                      v-if="getParameter('isDisplayed', 'rok_vyroby', tech.pkid)"
                    />
                  </v-col>
                  <v-col cols="4">
                    <numeric-text-box
                      class="dynamic-input-control"
                      label="Počet motohodín"
                      outlined
                      v-model="tech.pocet_motohodin"
                      :decimalPlaces="0"
                      :class="{
                        required: getParameter('isRequired', 'pocet_motohodin', tech.pkid),
                      }"
                      :isEnabled="getParameter('isEnabled', 'pocet_motohodin', tech.pkid)"
                      :rules="
                        getParameter('isRequired', 'pocet_motohodin', tech.pkid) ? requiredRule : []
                      "
                      v-if="getParameter('isDisplayed', 'pocet_motohodin', tech.pkid)"
                    />
                  </v-col>
                  <v-col cols="4">
                    <v-checkbox
                      class="dynamic_check_box"
                      label="Dovoz"
                      v-model="tech.dovoz"
                      :class="{
                        required: getParameter('isRequired', 'dovoz', tech.pkid),
                      }"
                      :disabled="!getParameter('isEnabled', 'dovoz', tech.pkid)"
                      :rules="getParameter('isRequired', 'dovoz', tech.pkid) ? requiredRule : []"
                      v-if="getParameter('isDisplayed', 'dovoz', tech.pkid)"
                      :false-value="0"
                      :true-value="1"
                      outlined
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="4">
                    <v-text-field
                      class="dynamic-input-control"
                      label="Výrobca"
                      v-model="tech.vyrobca"
                      :class="{
                        required: getParameter('isRequired', 'vyrobca', tech.pkid),
                      }"
                      :disabled="!getParameter('isEnabled', 'vyrobca', tech.pkid)"
                      :rules="getParameter('isRequired', 'vyrobca', tech.pkid) ? requiredRule : []"
                      v-if="getParameter('isDisplayed', 'vyrobca', tech.pkid)"
                      outlined
                    />
                  </v-col>
                  <v-col cols="4">
                    <v-autocomplete
                      append-icon="mdi-chevron-down"
                      outlined
                      class="dynamic-input-control"
                      label="Krajina pôvodu"
                      :items="krajinyPovoduData"
                      item-text="displayMember"
                      item-value="valueMember"
                      v-model="tech.id_krajiny_povodu"
                      :class="{
                        required: getParameter('isRequired', 'id_krajiny_povodu', tech.pkid),
                      }"
                      :disabled="!getParameter('isEnabled', 'id_krajiny_povodu', tech.pkid)"
                      :rules="
                        getParameter('isRequired', 'id_krajiny_povodu', tech.pkid)
                          ? requiredRule
                          : []
                      "
                      v-if="getParameter('isDisplayed', 'id_krajiny_povodu', tech.pkid)"
                    />
                  </v-col>
                  <v-col cols="4">
                    <v-checkbox
                      class="dynamic_check_box"
                      label="Technológia súčasťou nehnutelnosti"
                      v-model="tech.tech_sucast_nehnutelnosti"
                      :class="{
                        required: getParameter(
                          'isRequired',
                          'tech_sucast_nehnutelnosti',
                          tech.pkid
                        ),
                      }"
                      :disabled="!getParameter('isEnabled', 'tech_sucast_nehnutelnosti', tech.pkid)"
                      :rules="
                        getParameter('isRequired', 'tech_sucast_nehnutelnosti', tech.pkid)
                          ? requiredRule
                          : []
                      "
                      v-if="getParameter('isDisplayed', 'tech_sucast_nehnutelnosti', tech.pkid)"
                      outlined
                      :false-value="0"
                      :true-value="1"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="4">
                    <v-autocomplete
                      append-icon="mdi-chevron-down"
                      outlined
                      class="dynamic-input-control"
                      label="Spôsob nadobudnutia"
                      :items="sposobyNadobudnutiaData"
                      item-text="displayMember"
                      item-value="valueMember"
                      v-model="tech.id_sposobu_nadobudnutia"
                      :class="{
                        required: getParameter('isRequired', 'id_sposobu_nadobudnutia', tech.pkid),
                      }"
                      :disabled="!getParameter('isEnabled', 'id_sposobu_nadobudnutia', tech.pkid)"
                      :rules="
                        getParameter('isRequired', 'id_sposobu_nadobudnutia', tech.pkid)
                          ? requiredRule
                          : []
                      "
                      v-if="getParameter('isDisplayed', 'id_sposobu_nadobudnutia', tech.pkid)"
                    />
                  </v-col>
                  <v-col cols="4">
                    <v-autocomplete
                      append-icon="mdi-chevron-down"
                      outlined
                      class="dynamic-input-control"
                      label="Dodávateľ"
                      :items="tech.dodavateliaData"
                      item-text="display_member"
                      item-value="value_member"
                      v-model="tech.dodavatel_id"
                      @update:search-input="newVal => searchDodavatel(newVal, tech)"
                      :class="{
                        required: getParameter('isRequired', 'dodavatel_id', tech.pkid),
                      }"
                      :disabled="!getParameter('isEnabled', 'dodavatel_id', tech.pkid)"
                      :rules="
                        getParameter('isRequired', 'dodavatel_id', tech.pkid) ? requiredRule : []
                      "
                      v-if="getParameter('isDisplayed', 'dodavatel_id', tech.pkid)"
                    />
                  </v-col>
                </v-row>
              </div>
            </v-expand-transition>
          </v-form>
        </v-card>
      </div>

      <v-form ref="formAuto" autocomplete="off" v-if="jeAuto === true">
        <v-card class="mt-6 card" >
          <div class="d-flex">
            <h2 :class="{ 'mb-6': showInfo }">Doplnkové info</h2>
            <v-btn @click="showInfo = !showInfo" class="btn-secondary ml-auto" icon>
              <v-icon :class="{ 'rotate-180': showInfo }">mdi-chevron-down</v-icon>
            </v-btn>
          </div>
          <v-expand-transition>
            <div v-show="showInfo">
              <v-row>
                <v-col cols="4">
                  <v-text-field
                    class="dynamic-input-control"
                    label="Farba"
                    outlined
                    v-model="preberaciProtokol.farba"
                    :class="{
                      required: getParameter('isRequired', 'farba'),
                    }"
                    :disabled="!getParameter('isEnabled', 'farba')"
                    :rules="getParameter('isRequired', 'farba') ? requiredRule : []"
                    v-if="getParameter('isDisplayed', 'farba')"
                  />
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    class="dynamic-input-control"
                    label="EČV"
                    outlined
                    v-model="preberaciProtokol.spz"
                    :class="{
                      required: getParameter('isRequired', 'spz'),
                    }"
                    :disabled="!getParameter('isEnabled', 'spz')"
                    :rules="getParameter('isRequired', 'spz') ? requiredRule : []"
                    v-if="getParameter('isDisplayed', 'spz')"
                  />
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    class="dynamic-input-control"
                    label="Číslo veľkého TP"
                    outlined
                    v-model="preberaciProtokol.cislo_tp"
                    :class="{
                      required: getParameter('isRequired', 'cislo_tp'),
                    }"
                    :disabled="!getParameter('isEnabled', 'cislo_tp')"
                    :rules="
                      getParameter('isRequired', 'cislo_tp') ? tpRule.concat(requiredRule) : tpRule
                    "
                    v-if="getParameter('isDisplayed', 'cislo_tp')"
                  />
                </v-col>
                <v-col cols="4">
                  <v-autocomplete
                    append-icon="mdi-chevron-down"
                    outlined
                    class="dynamic-input-control"
                    label="Ocenenie vozidla"
                    :items="oceneniaData"
                    item-text="displayMember"
                    item-value="valueMember"
                    v-model="preberaciProtokol.id_ocenenie_vozidla"
                    :class="{
                      required: getParameter('isRequired', 'id_ocenenie_vozidla'),
                    }"
                    :disabled="!getParameter('isEnabled', 'id_ocenenie_vozidla')"
                    :rules="getParameter('isRequired', 'id_ocenenie_vozidla') ? requiredRule : []"
                    v-if="getParameter('isDisplayed', 'id_ocenenie_vozidla')"
                  />
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    class="dynamic-input-control"
                    label="Výrobca"
                    outlined
                    v-model="preberaciProtokol.vyrobca"
                    :class="{
                      required: getParameter('isRequired', 'vyrobca'),
                    }"
                    :disabled="!getParameter('isEnabled', 'vyrobca')"
                    :rules="getParameter('isRequired', 'vyrobca') ? requiredRule : []"
                    v-if="getParameter('isDisplayed', 'vyrobca')"
                  />
                </v-col>
                <v-col cols="4">
                  <numeric-text-box
                    class="dynamic-input-control"
                    label="Výmena oleja"
                    outlined
                    suffix="km"
                    v-model="preberaciProtokol.vymena_oleja"
                    :class="{
                      required: getParameter('isRequired', 'vymena_oleja'),
                    }"
                    :decimalPlaces="0"
                    :isEnabled="getParameter('isEnabled', 'vymena_oleja')"
                    :rules="getParameter('isRequired', 'vymena_oleja') ? requiredRule : []"
                    v-if="getParameter('isDisplayed', 'vymena_oleja')"
                  />
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    class="dynamic-input-control"
                    label="Krajina pôvodu"
                    outlined
                    v-model="preberaciProtokol.povod"
                    :class="{
                      required: getParameter('isRequired', 'povod'),
                    }"
                    :disabled="!getParameter('isEnabled', 'povod')"
                    :rules="getParameter('isRequired', 'povod') ? requiredRule : []"
                    v-if="getParameter('isDisplayed', 'povod')"
                  />
                </v-col>
                <v-col cols="4">
                  <numeric-text-box
                    class="dynamic-input-control"
                    label="Kontrola po"
                    outlined
                    suffix="km"
                    v-model="preberaciProtokol.kontrola"
                    :class="{
                      required: getParameter('isRequired', 'kontrola'),
                    }"
                    :decimalPlaces="0"
                    :isEnabled="getParameter('isEnabled', 'kontrola')"
                    :rules="getParameter('isRequired', 'kontrola') ? requiredRule : []"
                    v-if="getParameter('isDisplayed', 'kontrola')"
                  />
                </v-col>
                <v-col cols="4">
                  <numeric-text-box
                    class="dynamic-input-control"
                    label="Najväčšia príst. hmotn."
                    outlined
                    suffix="kg"
                    :decimalPlaces="0"
                    v-model="preberaciProtokol.najvacsia_pristupna_hmotnost"
                    :class="{
                      required: getParameter('isRequired', 'najvacsia_pristupna_hmotnost'),
                    }"
                    :isEnabled="getParameter('isEnabled', 'najvacsia_pristupna_hmotnost')"
                    :rules="
                      getParameter('isRequired', 'najvacsia_pristupna_hmotnost') ? requiredRule : []
                    "
                    v-if="getParameter('isDisplayed', 'najvacsia_pristupna_hmotnost')"
                  />
                </v-col>
                <v-col cols="4">
                  <date-picker
                    label="Prihlásenie na DI"
                    placeholder="DD/MM/YYYY"
                    v-model="preberaciProtokol.datum_prihlasenia_di"
                    :required="getParameter('isRequired', 'datum_prihlasenia_di')"
                    :isEnabled="getParameter('isEnabled', 'datum_prihlasenia_di')"
                    v-if="getParameter('isDisplayed', 'datum_prihlasenia_di')"
                  />
                </v-col>
                <v-col cols="4">
                  <numeric-text-box
                    class="dynamic-input-control"
                    label="Hmotnosť úžitková"
                    outlined
                    suffix="kg"
                    v-model="preberaciProtokol.hmotnost_uzitocna"
                    :class="{
                      required: getParameter('isRequired', 'hmotnost_uzitocna'),
                    }"
                    :decimalPlaces="0"
                    :isEnabled="getParameter('isEnabled', 'hmotnost_uzitocna')"
                    :rules="getParameter('isRequired', 'hmotnost_uzitocna') ? requiredRule : []"
                    v-if="getParameter('isDisplayed', 'hmotnost_uzitocna')"
                  />
                </v-col>
                <v-col cols="4">
                  <numeric-text-box
                    class="dynamic-input-control"
                    label="Pohotovostná hmotnosť"
                    outlined
                    suffix="kg"
                    :decimalPlaces="0"
                    v-model="preberaciProtokol.hmotnost_pohotovostna"
                    :class="{
                      required: getParameter('isRequired', 'hmotnost_pohotovostna'),
                    }"
                    :isEnabled="getParameter('isEnabled', 'hmotnost_pohotovostna')"
                    :rules="getParameter('isRequired', 'hmotnost_pohotovostna') ? requiredRule : []"
                    v-if="getParameter('isDisplayed', 'hmotnost_pohotovostna')"
                  />
                </v-col>
                <v-col cols="4">
                  <numeric-text-box
                    class="dynamic-input-control"
                    label="Spotreba v meste"
                    outlined
                    suffix="l/100 km"
                    v-model="preberaciProtokol.spotreba_mesto"
                    :class="{
                      required: getParameter('isRequired', 'spotreba_mesto'),
                    }"
                    :isEnabled="getParameter('isEnabled', 'spotreba_mesto')"
                    :rules="getParameter('isRequired', 'spotreba_mesto') ? requiredRule : []"
                    v-if="getParameter('isDisplayed', 'spotreba_mesto')"
                  />
                </v-col>
                <v-col cols="4">
                  <numeric-text-box
                    class="dynamic-input-control"
                    label="Spotreba mimo mesta"
                    outlined
                    suffix="l/100 km"
                    v-model="preberaciProtokol.spotreba_mimo"
                    :class="{
                      required: getParameter('isRequired', 'spotreba_mimo'),
                    }"
                    :isEnabled="getParameter('isEnabled', 'spotreba_mimo')"
                    :rules="getParameter('isRequired', 'spotreba_mimo') ? requiredRule : []"
                    v-if="getParameter('isDisplayed', 'spotreba_mimo')"
                  />
                </v-col>
                <v-col cols="4">
                  <numeric-text-box
                    class="dynamic-input-control"
                    label="Kombinovaná spotreba"
                    outlined
                    suffix="l/100 km"
                    v-model="preberaciProtokol.spotreba_kombi"
                    :class="{
                      required: getParameter('isRequired', 'spotreba_kombi'),
                    }"
                    :isEnabled="getParameter('isEnabled', 'spotreba_kombi')"
                    :rules="getParameter('isRequired', 'spotreba_kombi') ? requiredRule : []"
                    v-if="getParameter('isDisplayed', 'spotreba_kombi')"
                  />
                </v-col>
                <v-col cols="4">
                  <numeric-text-box
                    class="dynamic-input-control"
                    label="Počet sedadiel"
                    outlined
                    v-model="preberaciProtokol.pocet_sedadiel"
                    :class="{
                      required: getParameter('isRequired', 'pocet_sedadiel'),
                    }"
                    :decimalPlaces="0"
                    :isEnabled="getParameter('isEnabled', 'pocet_sedadiel')"
                    :rules="getParameter('isRequired', 'pocet_sedadiel') ? requiredRule : []"
                    v-if="getParameter('isDisplayed', 'pocet_sedadiel')"
                  />
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    class="dynamic-input-control"
                    label="Číslo motora"
                    outlined
                    v-model="preberaciProtokol.cislo_motora"
                    :class="{
                      required: getParameter('isRequired', 'cislo_motora'),
                    }"
                    :disabled="!getParameter('isEnabled', 'cislo_motora')"
                    :rules="getParameter('isRequired', 'cislo_motora') ? requiredRule : []"
                    v-if="getParameter('isDisplayed', 'cislo_motora')"
                  />
                </v-col>
                <v-col cols="4">
                  <numeric-text-box
                    class="dynamic-input-control"
                    label="Záruka motora"
                    outlined
                    suffix="roky"
                    v-model="preberaciProtokol.zaruka_motor_roky"
                    :class="{
                      required: getParameter('isRequired', 'zaruka_motor_roky'),
                    }"
                    :decimalPlaces="0"
                    :isEnabled="getParameter('isEnabled', 'zaruka_motor_roky')"
                    :rules="getParameter('isRequired', 'zaruka_motor_roky') ? requiredRule : []"
                    v-if="getParameter('isDisplayed', 'zaruka_motor_roky')"
                  />
                </v-col>
                <v-col cols="4">
                  <numeric-text-box
                    class="dynamic-input-control"
                    label="Dohodnutý počet km/rok"
                    outlined
                    suffix="km"
                    v-model="preberaciProtokol.dohodnuty_poc_km_rok"
                    :class="{
                      required: getParameter('isRequired', 'dohodnuty_poc_km_rok'),
                    }"
                    :decimalPlaces="0"
                    :isEnabled="getParameter('isEnabled', 'dohodnuty_poc_km_rok')"
                    :rules="getParameter('isRequired', 'dohodnuty_poc_km_rok') ? requiredRule : []"
                    v-if="getParameter('isDisplayed', 'dohodnuty_poc_km_rok')"
                  />
                </v-col>
                <v-col cols="4">
                  <numeric-text-box
                    class="dynamic-input-control"
                    label="Maximálna rýchlosť"
                    outlined
                    suffix="km/h"
                    v-model="preberaciProtokol.max_rychlost"
                    :class="{
                      required: getParameter('isRequired', 'max_rychlost'),
                    }"
                    :decimalPlaces="0"
                    :isEnabled="getParameter('isEnabled', 'max_rychlost')"
                    :rules="getParameter('isRequired', 'max_rychlost') ? requiredRule : []"
                    v-if="getParameter('isDisplayed', 'max_rychlost')"
                  />
                </v-col>
                <v-col cols="4">
                  <numeric-text-box
                    class="dynamic-input-control"
                    label="Záruka na karosériu"
                    outlined
                    suffix="roky"
                    v-model="preberaciProtokol.zaruka_karoseria"
                    :class="{
                      required: getParameter('isRequired', 'zaruka_karoseria'),
                    }"
                    :decimalPlaces="0"
                    :isEnabled="getParameter('isEnabled', 'zaruka_karoseria')"
                    :rules="getParameter('isRequired', 'zaruka_karoseria') ? requiredRule : []"
                    v-if="getParameter('isDisplayed', 'zaruka_karoseria')"
                  />
                </v-col>
                <v-col cols="4">
                  <numeric-text-box
                    class="dynamic-input-control"
                    label="Počet dverí"
                    outlined
                    v-model="preberaciProtokol.pocet_dveri"
                    :class="{
                      required: getParameter('isRequired', 'pocet_dveri'),
                    }"
                    :decimalPlaces="0"
                    :disabled="!getParameter('isEnabled', 'pocet_dveri')"
                    :rules="getParameter('isRequired', 'pocet_dveri') ? requiredRule : []"
                    v-if="getParameter('isDisplayed', 'pocet_dveri')"
                  />
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    class="dynamic-input-control"
                    label="Preferovaný servis"
                    outlined
                    v-model="preberaciProtokol.preferovany_servis"
                    :class="{
                      required: getParameter('isRequired', 'preferovany_servis'),
                    }"
                    :disabled="!getParameter('isEnabled', 'preferovany_servis')"
                    :rules="getParameter('isRequired', 'preferovany_servis') ? requiredRule : []"
                    v-if="getParameter('isDisplayed', 'preferovany_servis')"
                  />
                </v-col>
                <v-col cols="4">
                  <v-autocomplete
                    append-icon="mdi-chevron-down"
                    outlined
                    class="dynamic-input-control"
                    label="Rozmer diskov"
                    :items="rozmeryDiskovData"
                    item-text="displayMember"
                    item-value="valueMember"
                    v-model="preberaciProtokol.rozmer_diskov"
                    :class="{
                      required: getParameter('isRequired', 'rozmer_diskov'),
                    }"
                    :disabled="!getParameter('isEnabled', 'rozmer_diskov')"
                    :rules="getParameter('isRequired', 'rozmer_diskov') ? requiredRule : []"
                    v-if="getParameter('isDisplayed', 'rozmer_diskov')"
                  />
                </v-col>
                <v-col cols="4">
                  <v-autocomplete
                    append-icon="mdi-chevron-down"
                    outlined
                    class="dynamic-input-control"
                    label="Spôsob nadobudnutia"
                    :items="sposobyNadobudnutiaData"
                    item-text="displayMember"
                    item-value="valueMember"
                    v-model="preberaciProtokol.id_sposobu_nadobudnutia"
                    :class="{
                      required: getParameter('isRequired', 'id_sposobu_nadobudnutia'),
                    }"
                    :disabled="!getParameter('isEnabled', 'id_sposobu_nadobudnutia')"
                    :rules="
                      getParameter('isRequired', 'id_sposobu_nadobudnutia') ? requiredRule : []
                    "
                    v-if="getParameter('isDisplayed', 'id_sposobu_nadobudnutia')"
                  />
                </v-col>
                <v-col cols="4">
                  <v-autocomplete
                    append-icon="mdi-chevron-down"
                    outlined
                    class="dynamic-input-control"
                    label="Rozmer pneu"
                    :items="rozmeryPneuData"
                    item-text="displayMember"
                    item-value="valueMember"
                    v-model="preberaciProtokol.rozmer_pneu"
                    :class="{
                      required: getParameter('isRequired', 'rozmer_pneu'),
                    }"
                    :disabled="!getParameter('isEnabled', 'rozmer_pneu')"
                    :rules="getParameter('isRequired', 'rozmer_pneu') ? requiredRule : []"
                    v-if="getParameter('isDisplayed', 'rozmer_pneu')"
                  />
                </v-col>
                <v-col cols="4">
                  <v-autocomplete
                    append-icon="mdi-chevron-down"
                    outlined
                    class="dynamic-input-control"
                    label="Emisie"
                    :items="emisieData"
                    item-text="displayMember"
                    item-value="valueMember"
                    v-model="preberaciProtokol.id_emisie"
                    :class="{
                      required: getParameter('isRequired', 'id_emisie'),
                    }"
                    :disabled="!getParameter('isEnabled', 'id_emisie')"
                    :rules="getParameter('isRequired', 'id_emisie') ? requiredRule : []"
                    v-if="getParameter('isDisplayed', 'id_emisie')"
                  />
                </v-col>
                <v-col cols="4">
                  <v-autocomplete
                    append-icon="mdi-chevron-down"
                    outlined
                    class="dynamic-input-control"
                    label="Kategória vozidla"
                    :items="kategorieData"
                    item-text="displayMember"
                    item-value="valueMember"
                    v-model="preberaciProtokol.id_ketegorie_vozidla"
                    :class="{
                      required: getParameter('isRequired', 'id_ketegorie_vozidla'),
                    }"
                    :disabled="!getParameter('isEnabled', 'id_ketegorie_vozidla')"
                    :rules="getParameter('isRequired', 'id_ketegorie_vozidla') ? requiredRule : []"
                    v-if="getParameter('isDisplayed', 'id_ketegorie_vozidla')"
                  />
                </v-col>
              </v-row>
            </div>
          </v-expand-transition>
        </v-card>
        <v-card class="mt-6 card">
          <div class="d-flex">
            <h2 :class="{ 'mb-6': showVybava }">Výbava</h2>
            <v-btn @click="showVybava = !showVybava" class="btn-secondary ml-auto" icon>
              <v-icon :class="{ 'rotate-180': showVybava }">mdi-chevron-down</v-icon>
            </v-btn>
          </div>
          <v-expand-transition>
            <div v-show="showVybava">
              <v-data-table
                class="standard-table"
                :headers="headers"
                v-model="selected"
                @page-count="pageCount = $event"
                :items="vybavaItems"
                show-select
                item-key="pkid"
              >
                <template v-slot:[`item.data-table-select`]="{ isSelected, select }">
                  <v-simple-checkbox
                    class="dynamic_check_box"
                    :value="isSelected"
                    @input="select($event)"
                    :ripple="false"
                  ></v-simple-checkbox>
                </template>
                <template v-slot:[`item.nazov`]="{ item }">
                  {{ item.nazov }}
                </template>
                <template v-slot:[`item.popis`]="{ item }">
                  <v-text-field
                    v-model="item.popis"
                    dense
                    solo
                    hide-details
                    label="Vložte popis"
                    class="dynamic-input-control dense"
                    outlined
                  />
                </template>
              </v-data-table>
            </div>
          </v-expand-transition>
        </v-card>
      </v-form>
      <div v-if="!jeAuto" class="mt-20px" style="display: flex">
        <div>Spolu: {{ spolu }}€</div>
        <div style="margin-left: 20px">Rozdiel: {{ rozdiel }}€</div>
      </div>
      <div style="display: flex">
        <v-tooltip top :close-delay="0" :open-delay="200" v-if="!jeAuto">
          <template v-slot:activator="{ on }">
            <v-btn class="btn-secondary mt-20px" v-on="on" @click="addTechnologia()"
              ><v-icon class="f18 mr-6px">mdi-upload-outline</v-icon></v-btn
            >
          </template>
          <span>Pridať</span>
        </v-tooltip>
        <v-spacer></v-spacer>
        <v-btn class="btn-secondary mt-20px mr-20px right" to="/obchodne-pripady">Zatvoriť</v-btn>
        <v-btn class="btn-primary mt-20px" :disabled="vinLoading" @click="ulozit()">Uložiť</v-btn>
      </div>
    </v-container>
  </div>
</template>
<script>
import DatePicker from '../components/basic/DatePicker.vue';
import Date from '../components/basic/DatePicker.vue';
import NumericTextBox from '../components/basic/NumericTextBox.vue';
import ButtonGroup from '../components/basic/ButtonGroup.vue';
import protectedAxios from '../auth/axios.js';
import { comboMixin } from '../mixins/comboMixin.js';
import Utils from '../plugins/utils';
import { eventBus } from '../main.js';
import { mapMutations } from 'vuex';

export default {
  mixins: [comboMixin],
  components: {
    DatePicker,
    Date,
    NumericTextBox,
    ButtonGroup,
  },
  computed: {
    spolu() {
      return this.preberaciProtokolTechnologie.reduce((a, b) => a + (b.cena_bez_dph || 0), 0);
    },
    rozdiel() {
      return Math.abs(this.preberaciProtokol.oc_bez_dph - this.spolu);
    },
  },
  data() {
    return {
      formKey: 0,
      overlayTimeout: null,
      newId: '',
      cisloPredmetu: -1,
      jeAuto: null,
      showInfo: false,
      showVybava: false,
      isLoading: true,
      requiredRule: [value => !!value || 'Pole je povinné'],
      vinUsedRule: () => !this.vinAlreadyUsed || this.vinUsedMsg,
      tpRule: [value => String(value).length < 20 || 'Pole môže mať iba 20 znakov'],
      pageCount: 0,
      selected: [],
      combos: [
        {
          key: 'sposoby-nadobudnutia',
        },
        {
          key: 'staty',
        },
        {
          key: 'druhy-tovaru',
        },
        {
          key: 'typy-motora',
        },
        {
          key: 'druhy-vozidla',
        },
        {
          key: 'velkost-diskov',
        },
        {
          key: 'sposoby-nadobudnutia',
        },
        {
          key: 'pneu-rozmer',
        },
        {
          key: 'emisie',
        },
        {
          key: 'typy-cennikov',
        },
      ],
      vybavaItems: [],
      jazdenyItems: [
        { valueMember: 0, displayMember: 'Nový predmet' },
        { valueMember: 1, displayMember: 'Použitý predmet' },
      ],
      headers: [
        { text: 'Názov', value: 'nazov' },
        { text: 'Popis', value: 'popis' },
      ],
      krajinyPovoduData: [],
      druhyTovaruData: [],
      typyMotoraData: [],
      oceneniaData: [],
      rozmeryDiskovData: [],
      rozmeryPneuData: [],
      sposobyNadobudnutiaData: [],
      emisieData: [],
      kategorieData: [],
      preberaciProtokolTechnologieData: [],
      preberaciProtokolTechnologie: [],
      preberaciProtokolTechnologiaTemplate: {
        pkid: null,
        nazov_predmetu: 'Nová položka',
        vyrobne_cislo: null,
        cena_bez_dph: null,
        dodavatel_id: null,
        rok_vyroby: null,
        pocet_motohodin: null,
        dovoz: null,
        vyrobca: null,
        id_krajiny_povodu: null,
        tech_sucast_nehnutelnosti: null,
        prislusenstvo: null,
        id_sposobu_nadobudnutia: null,
        dodavateliaData: [],
        active: true,
        dodavatelSearchTimeout: null,
      },
      preberaciProtokolData: null,
      preberaciProtokol: {
        datum_prvej_platby: null,
        datum_prebratia: null,
        ma_overeny_pp: null,
        id_druhu_tovaru: null,
        ojazdene_vozidlo: null,
        nazov: null,
        specifikacia: null,
        datum_vystavenia_oev: null,
        datum_dodania_oev: null,
        znacka: null,
        model: null,
        miesto_prevadzky: null,
        verzia_modelu: null,
        vyrobne_cislo: null,
        cennikova_cena_s_dph: null,
        vykon_motora: null,
        objem_motora: null,
        pociatocny_stav_km: null,
        hmotnost_celkova: null,
        rok_vyroby: null,
        datum_1_evidencie: null,
        pocet_naprav: null,
        typ_motora: null,
        farba: null,
        spz: null,
        cislo_tp: null,
        id_ocenenie_vozidla: null,
        vyrobca: null,
        vymena_oleja: null,
        povod: null,
        kontrola: null,
        najvacsia_pristupna_hmotnost: null,
        datum_prihlasenia_di: null,
        hmotnost_uzitocna: null,
        hmotnost_pohotovostna: null,
        spotreba_mesto: null,
        spotreba_mimo: null,
        spotreba_kombi: null,
        pocet_sedadiel: null,
        cislo_motora: null,
        zaruka_motor_roky: null,
        dohodnuty_poc_km_rok: null,
        max_rychlost: null,
        zaruka_karoseria: null,
        pocet_dveri: null,
        preferovany_servis: null,
        rozmer_diskov: null,
        rozmer_pneu: null,
        id_sposobu_nadobudnutia: null,
        id_emisie: null,
        id_ketegorie_vozidla: null,
        oc_bez_dph: null,
      },
      vinLoading: false,
      vinChecked: false, //ci prebehla kontrola z car catalogu
      vinAlreadyUsed: false, //servis vin-check, pozre ci uz vin je pouzite inde
      vinAlreadyChecked: false, //ci uz sa checkovalo vin
      vinUsedMsg: '',
      // showCenaWarning: false,
      isSaving: false,
    };
  },
  watch: {
    vinAlreadyUsed() {
      this.$refs.formBasicInfo.validate();
    },
  },
  methods: {
    ...mapMutations(['openDialog']),
    getParameter(paramName, parameter, pkid = null) {
      if (pkid === null && !this.preberaciProtokolData) return false;
      if (pkid !== null && !this.preberaciProtokolTechnologieData) return false;

      try {
        let elem = null;
        if (pkid === null) {
          elem = this.preberaciProtokolData.find(e => e.columnName === parameter);
        } else {
          const technologia = this.preberaciProtokolTechnologieData.find(x =>
            parseInt(x.find(z => z.columnName.toLowerCase() === 'pkid').controlValue ?? 0) ===
            pkid < 0
              ? 0
              : pkid
          );
          if (technologia) elem = technologia.find(e => e.columnName === parameter);
        }

        if (paramName === 'isEnabled') return !!elem?.isEnabled;

        if (paramName === 'isRequired') return !!elem?.isRequired;

        if (paramName === 'isDisplayed') return elem ? true : false;

        if (!paramName) return elem;
      } catch (e) {
        console.error(paramName, parameter, e);
      }
    },
    async checkVin(vinInputChanged) {
      if (vinInputChanged) {
        this.vinAlreadyChecked = false;
        this.vinAlreadyUsed = false;
      }
      if (this.vinAlreadyChecked) return;

      if (
        !this.preberaciProtokol.vyrobne_cislo ||
        this.preberaciProtokol.vyrobne_cislo.length < 14
      ) {
        return;
      }

      this.vinLoading = true;
      const vinMsg = await protectedAxios
        .get(
          `/pripady/${this.newId}/predmety/${
            this.cisloPredmetu
          }/check-vin?vin=${this.preberaciProtokol.vyrobne_cislo}`
        )
        .then(res => res.data);

      if (vinMsg) {
        this.vinUsedMsg = vinMsg;
        this.vinAlreadyUsed = true;
      } else {
        this.vinAlreadyUsed = false;
      }

      await protectedAxios
        .get(
          `/pripady/${this.newId}/predmety/${
            this.cisloPredmetu
          }/check-vin-car-catalog?vin=${this.preberaciProtokol.vyrobne_cislo}&noCache=true`
        )
        .then(res => {
          if (res.data.vinCheck.error != 0) {
            eventBus.$emit('snack-error', res.data.vinCheck.errorText);
          }
          if (res.data.registerVozidiel.error != 0) {
            eventBus.$emit('snack-error', res.data.registerVozidiel.errorText);
          } else {
            this.vinChecked = true;
          }
        });
      this.vinLoading = false;
      this.vinAlreadyChecked = true;
    },
    async getPreberaciProtokol() {
      return protectedAxios
        .get(
          `/pripady/${this.newId}/predmety/${
            this.cisloPredmetu
          }/preberaci-protokol`
        )
        .then(res => {
          // console.log(
          //   res.data.map(x => ({
          //     cn: x.columnName,
          //     cv: x.controlValue,
          //     en: x.isEnabled,
          //     req: x.isRequired,
          //   }))
          // );
          this.getItemsFromResponse(res);
        })
        .catch(e => console.error('Pri overení predmetu nastala chyba.', e));
    },
    async getVybava() {
      return protectedAxios
        .get(
          `/pripady/${this.newId}/predmety/${
            this.cisloPredmetu
          }/preberaci-protokol/vybava`
        )
        .then(res => {
          this.vybavaItems = res.data;
          this.selected = this.vybavaItems.filter(s => s.selected === 1);
        });
    },
    async getPolozky() {
      return protectedAxios
        .get(
          `/pripady/${this.newId}/predmety/${
            this.cisloPredmetu
          }/preberaci-protokol/polozky`
        )
        .then(res => {
          this.preberaciProtokolTechnologie = [];
          this.preberaciProtokolTechnologieData = res.data.sort((a, b) => b.pkid - a.pkid);
          this.preberaciProtokolTechnologieData.forEach(data => {
            this.formatTechnologia(data);
          });
          this.setLoading(false);
        });
    },
    async getJeAuto() {
      return protectedAxios
        .get(
          `/pripady/${this.newId}/predmety/${
            this.cisloPredmetu
          }/je-auto`
        )
        .then(res => {
          this.jeAuto = res.data;
        });
    },
    async getDodavatelia(query, idDodavatela) {
      return this.loadCombo({
        key: 'dodavatelia',
        params: { idDodavatela: idDodavatela ?? null, query: query },
      });
    },
    searchDodavatel(val, technologia) {
      if (val === null) return;
      if (
        technologia.dodavateliaData.find(d => d.value_member === technologia.dodavatel_id)
          ?.display_member === val
      ) {
        return;
      }
      if (!val || val.length < 3) {
        technologia.dodavateliaData = [];
        return;
      }

      clearTimeout(technologia.dodavatelSearchTimeout);

      technologia.dodavatelSearchTimeout = setTimeout(
        () =>
          this.getDodavatelia(val, null).then(res => {
            technologia.dodavateliaData = res.data;
          }),
        500
      );
    },
    getItemsFromResponse(res) {
      this.preberaciProtokolData = res.data;
      this.preberaciProtokolData.forEach(predmet => {
        let val = predmet.controlValue;
        if (val === '') val = null;
        const intVal = val?.toStrictInt();
        this.preberaciProtokol[predmet.columnName] = !intVal && intVal !== 0 ? val : intVal;
      });
      this.formKey++;
    },
    async formatTechnologia(data) {
      if (!data.find(z => z.columnName === 'pkid').controlValue) return;

      const technologia = { ...this.preberaciProtokolTechnologiaTemplate };
      Object.entries(technologia).forEach(e => {
        const [key, value] = e;

        const dataObj = data.find(e => e.columnName.toLowerCase() === key);

        if (dataObj) {
          if (dataObj.controlValue === '') dataObj.controlValue = null;
          const intVal = dataObj.controlValue?.toStrictInt();
          //console.log(key, dataObj.controlValue, intVal);
          technologia[key] = !intVal && intVal !== 0 ? dataObj.controlValue : intVal;
        } else technologia[key] = value;
      });
      await this.getDodavatelia(null, technologia.dodavatel_id).then(res => {
        technologia.dodavateliaData = res.data;
      });
      this.preberaciProtokolTechnologie.push(technologia);
    },
    addTechnologia() {
      const technologia = { ...this.preberaciProtokolTechnologiaTemplate };
      technologia.pkid = Math.max.apply(
        Math,
        this.preberaciProtokolTechnologie.map(pt => {
          return pt.pkid;
        })
      );
      technologia.pkid++;
      this.preberaciProtokolTechnologie.push(technologia);

      setTimeout(() => {
        this.$vuetify.goTo(`#technologia${technologia.pkid}`, {
          duration: 500,
          easing: 'easeInOutCubic',
        });
      }, 200);
    },
    removeTechnologia(technologia) {
      const index = this.preberaciProtokolTechnologie.indexOf(technologia);
      if (index > -1) {
        this.preberaciProtokolTechnologie.splice(index, 1);
      }
    },
    async ulozit() {
      let isValid = true;
      let scrollTo = null;
      isValid = this.$refs.formBasicInfo.validate();

      await this.checkVin(false);
      if (this.vinAlreadyUsed) return;

      if (this.jeAuto) {
        isValid = isValid && this.$refs.formAuto.validate();
      } else {
        if (this.rozdiel > 0) {
          let _dialog = {
            persistent: true,
            header: `<span class="gs100 f16">Upozornenie</span>`,
            closeIcon: {
              value: true,
            },
            textClass: ['f16', 'white100'],
            text: `Suma cien položiek technológie nie je rovnaká ako cena predmetu bez DPH. Upravte prosím
          ceny položiek.`,
            closeBtn: {
              value: true,
              text: 'OK',
            },
          };

          this.openDialog(_dialog);
          // this.showCenaWarning = true;
          return;
        }
        this.preberaciProtokolTechnologie.forEach(tech => {
          const v = this.$refs['form' + tech.pkid][0].validate();
          if (!v) {
            scrollTo = '#technologia' + tech.pkid;
            isValid = isValid && v;
          }
        });
      }

      if (scrollTo)
        setTimeout(() => {
          this.$vuetify.goTo(scrollTo, { duration: 500, easing: 'easeInOutCubic' });
        }, 200);
      else if (!scrollTo && !isValid)
        this.$vuetify.goTo(0, { duration: 500, easing: 'easeInOutCubic' });

      if (!isValid) {
        eventBus.$emit('snack-error', 'Pre uloženie prosím vyplňte všetky povinné polia!');
        return;
      }

      let info = Utils.modelToPostData(this.preberaciProtokol);
      let tech = [];
      let vybava = [];

      if (!this.jeAuto) {
        this.preberaciProtokolTechnologie.forEach(t => {
          tech.push(Utils.modelToPostData(t));
        });
      }
      // console.log('info', info);
      // console.log('tech', tech);
      // console.log(
      //   'selected',
      //   this.selected.map(s => {
      //     return { pkid: s.pkid, popis: s.popis };
      //   })
      // );
      this.setLoading(true, true);
      protectedAxios
        .post(
          `/pripady/${this.newId}/predmety/${
            this.cisloPredmetu
          }/preberaci-protokol`,
          {
            checked: this.vinChecked,
            info: info,
            techPolozky: tech,
            vybava: this.selected.map(s => {
              return { pkid: s.pkid, popis: s.popis };
            }),
          },
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
        )
        .then(res => {
          if (res.data.error !== 0) {
            eventBus.$emit('snack-error', res.data.error_text);
          }
          eventBus.$emit('snack-info', 'Dáta boli úspešne uložené.');
          this.reload();
        })
        .finally(() => {
          this.setLoading(false);
        });
    },
    async reload() {
      this.setLoading(true);
      await this.getJeAuto();
      await this.loadCombos(this.combos).then(res => {
        this.druhyTovaruData = res.find(d => d.key === 'druhy-tovaru')?.data;
        this.typyMotoraData = res.find(d => d.key === 'typy-motora')?.data;
        this.rozmeryDiskovData = res.find(d => d.key === 'velkost-diskov')?.data;
        this.rozmeryPneuData = res.find(d => d.key === 'pneu-rozmer')?.data;
        this.sposobyNadobudnutiaData = res.find(d => d.key === 'sposoby-nadobudnutia')?.data;
        this.kategorieData = res.find(d => d.key === 'druhy-vozidla')?.data;
        this.emisieData = res.find(d => d.key === 'emisie')?.data;
        this.oceneniaData = res.find(d => d.key === 'typy-cennikov')?.data;
        this.sposobyNadobudnutiaData = res.find(d => d.key === 'sposoby-nadobudnutia')?.data;
        this.krajinyPovoduData = res.find(d => d.key === 'staty')?.data;
      });
      await this.getPreberaciProtokol();

      if (this.jeAuto) {
        await this.getVybava();
        this.setLoading(false);
      } else {
        await this.getPolozky();
      }
    },
    setLoading(val, saving) {
      let time = this.jeAuto ? 200 : 1000; //vykresluju sa tam polozky technologie treba aspon sekundu
      clearTimeout(this.overlayTimeout);

      if (!val)
        this.overlayTimeout = setTimeout(() => {
          this.isLoading = false;
          this.isSaving = false;
        }, time);
      else {
        this.isLoading = true;
        this.isSaving = saving;
      }
    },
  },
  async mounted() {
    this.newId = this.$route.params.new_id;
    this.cisloPredmetu = parseInt(this.$route.params.cislo_predmetu ?? 1);

    this.reload();
  },
};
</script>
